<template>
    <div class="form-template">

        <Section>
            <div class="top-describe">
                <div class="describe-left">
                    <p><b>{{title}}</b></p>
                    <P>{{remark}}</P>
                </div>
            </div>
        </Section>

        <Section>
            <div class="content-title">
                <b>{{title}}</b>
            </div>
            <div class="content-title">
               <Input v-model="searchInput" @input="searchMap" placeholder="搜索已绑定的儿童昵称/家长手机号码/手环MAC地址" style="width: 350px" />
               <div class="state">
                    <p class="green">
                        <span>● 在线：</span>
                        <span>{{online}}</span>
                    </p>
                    <p class="gray">
                        <span>● 离线：</span>
                        <span>{{offline}}</span>
                    </p>
                    <p class="red">
                        <span>● 未处理报警：</span>
                        <span>{{undisposed}}</span>
                    </p>
                </div>
            </div>
            <div class="bottom-cen">
                <div id="brtmap"></div>

            </div>

        </Section>


    </div>
</template>

<script>
    import LabelHeader from '@/modules/LabelHeader';
    import menuUtil from '../../../utils/menu-list.js';
    import utils from '../../../utils/util';
    import {Row,Col, Input, Button, Form, FormItem , RadioGroup, Radio, CheckboxGroup, Checkbox ,Modal ,Icon, } from 'iview';


    export default {
        name: "Form1",
        data () {
            return {
                title:'',
                remark:'',
                searchInput:'',
                floors:'',
                macAry:[],
                online:0,
                offline:0,
                undisposed:0,
                $search:'',
                searchAry:[],
                nowFloorId:'',
                routesn:'',
                first:false

            }
        },
        methods:{
             //加载地图
            uploadMap(){
                const s = document.createElement('script');
                s.type = 'text/javascript';
                s.src = 'https://files.brtbeacon.net/BRTMap/3D/brtmap-2.3.2.js';
                document.body.appendChild(s);
                s.onload = ()=>{

                    //初始化
                    this.$Map = new brtmap.Map({
                        container: 'brtmap',
                        token: this.$Build.token,
                        buildingID:this.$route.params.buildingId,
                        floorID:'',
                        zoom:20

                    });

                    this.$search = new brtmap.Search().addTo(this.$Map);

                    //地图加载完毕

                    //楼层切换后
                    this.$Map.on('floorend',() =>{
                        this.floors = this.$Build.floorList;
                        this.nowFloorId = this.$Map.currentMapInfo.floorID;
                        this.search();
                    })


                    this.$Map.on('click',(e)=>{
                        console.log(e)
                        this.$Map.easeTo({
                            center: e.lngLat,
                            zoom: 20
                        });
                    })


                }
            },
            //查询
            search(){
                let handRingInfo =  this.$route.params.handRingInfo;

                if(handRingInfo){
                    this.searchAry.length = 0;
                    this.searchAry.push(handRingInfo);

                    let fl = JSON.parse(handRingInfo.point).floor;
                    this.routesn = handRingInfo.sn
                    let flid;
                    this.floors.forEach(item =>{
                        if(item.floor == fl){
                            flid = item.floorId;
                        }
                    })
                    if(this.nowFloorId != flid){
                        this.$Map.setFloor(flid);
                        this.labelMap();
                    }

                }
                else{
                    let sear = ()=>{
                        this.$request.get(`${this.$HOST}/back/handRingInfo/find?buildingId=${this.$route.params.buildingId}`)
                        .then(response =>{
                            this.online = 0;
                            this.offline = 0;
                            // console.log(response);
                            if(response.data.code == 0){
                                this.undisposed = response.data.data.Alarming;
                                let res = response.data.result;
                                this.searchAry.length = 0;
                                res.forEach(item =>{
                                    this.searchAry.push(item)
                                    item.status == '0' ? this.offline = this.offline + 1 : this.online = this.online + 1;
                                })
                                this.labelMap();
                            }
                        })
                    };
                    setInterval(sear, 3000);
                }
            },
            //地图标注
            labelMap(){

                this.searchAry.forEach(item =>{

                    if(item.point){
                        let x = JSON.parse(item.point).x;
                        let y = JSON.parse(item.point).y;
                        let geographic = this.$Map.coordsToLnglat({x: x, y: y});
                        let floor = JSON.parse(item.point).floor;
                        let floorID;
                        let floorName;
                        this.floors.forEach(item =>{
                            if(item.floor == floor){
                                floorID = item.floorId;
                                floorName = item.floorName
                            }
                        })
                        if(floorID ==this.nowFloorId){

                            if(item.category){//报警
                                let $div = new brtmap.Symbol.DivMarker({
                                content:`<div class="normal">
                                <div class="red-box"></div>
                                <div class="normal-box red-main">
                                    <p class="top">${item.category == 'leaveFloor' ? '离开楼层报警' : item.category == 'over' ? '进入报警' : '距离报警'}</p>
                                    <p><span class="person"></span><span>${item.name}</span></p>
                                    <p><span class="phone"></span><span>${item.phone}</span></p>
                                    <p><span class="address"></span><span>${item.sn}</span></p>
                                    <div class="down"></div>
                                </div></div>`,
                                }).addTo(this.$Map);

                                $div.setLnglat(geographic);
                                this.renderFunc(item,floorName)

                            }
                            else{//正常
                                let $div = new brtmap.Symbol.DivMarker({
                                    content:`<div class="normal">
                                    <div class="img-box"></div>
                                    <div class="normal-box">
                                        <p><span class="person"></span><span>${item.name}</span></p>
                                        <p><span class="phone"></span><span>${item.phone}</span></p>
                                        <p><span class="address"></span><span>${item.sn}</span></p>
                                        <div class="down"></div>
                                    </div></div>`,
                                    }).addTo(this.$Map);
                                    let x = JSON.parse(item.point).x;
                                    let y = JSON.parse(item.point).y;

                                    let geographic = this.$Map.coordsToLnglat({x: x, y: y});
                                    $div.setLnglat(geographic);

                                    if(this.$route.params.handRingInfo){
                                        this.searchMap(this.routesn)
                                    }
                            }

                        }
                    }
                })

            },
            //地图搜索
            searchMap(value){
                let point;
                let floorId;
                console.log(this.searchAry)
                this.searchAry.forEach(item =>{
                    if(value == item.sn || value == item.name || value == item.phone){
                        point = JSON.parse(item.point);
                    }
                })

                if(point){
                    this.floors.forEach(item =>{
                        if(item.floor == point.floor){
                             floorId = item.floorId
                        }
                    })
                    if(floorId != this.$Map.currentMapInfo.floorID){
                        this.$Map.setFloor(floorId);
                        setTimeout(()=>{
                            this.$Map.easeTo({
                                center: this.$Map.coordsToLnglat(point.x, point.y),
                                zoom: 20
                            })
                        },1000)

                    }
                    else{
                        //console.log("132456",this.$Map.coordsToLnglat(point.x, point.y));
                        setTimeout(()=>{
                            this.$Map.easeTo({
                                center: this.$Map.coordsToLnglat(point.x, point.y),
                                zoom: 20
                            })
                        },1000)
                    }
                }


            },
            //通知提醒
            renderFunc (item,floorName) {
                if(this.macAry.includes(item.sn)){
                    return false
                }
                else{
                    this.macAry.push(item.sn)

                    let type;
                    item.category == 'leaveFloor' ? type = '离开楼层报警' : item.category == 'over' ? type = '进入报警' : type = '距离报警'
                    let tiem = utils.dateFormat(item.createdTime,'yyyy/MM/dd hh:mm:ss')
                    let name = item.name;
                    this.$Notice.open({
                        duration:3,
                        render: h => {

                            let boxStyle = {
                                'background-color':'#ffdcd0'
                            };
                            let titleStyle = {
                                color:'#f53100',
                                'font-size':'14px',
                                'font-weight':'bold',
                                'line-height':'30px',
                            }

                            let styles = {
                                'line-height':'20px',
                                color:'#f13e43'
                            };
                            let imgStyle = {
                                display:'inline-block',
                                width:'18px',
                                height:'18px',
                                'margin-right':'5px'
                            }
                            return h('div', {style:boxStyle},[
                                h('p',{style:titleStyle} ,[
                                    h('img',{style:imgStyle,attrs: {src: require('../../../../public/images/police.png'),}}),
                                    h('span',type)
                                ]),
                                h('p',{style:styles},`${name}，${tiem}，${floorName}`),

                            ])
                        }
                    });
                }
            }


        },
        mounted(){
            let menuObj = menuUtil.getRemark(this.$router.history.current.path);
            this.title = menuObj.menuName;
            this.remark = menuObj.remark;
        },
        created(){
           this.uploadMap();

        },
        components: {
            Row,
            Col,
            Input,
            Button,
            Form,
            FormItem,
            RadioGroup,
            Radio,
            CheckboxGroup,
            Checkbox,
            LabelHeader,
            Modal,
            Icon,
        }
    }
</script>

<style lang="less">
    @import '../../../styles/comm';
    .top-describe{
        height: 105px;
        padding: 20px;
        box-sizing: border-box;
        background-color: @ThemeReverseColor;
        box-shadow: 0 0 5px #EEEEEE;
        border-radius: 3px;
        margin-bottom: 20px;
        .describe-left{
            float: left;
            width: 85%;
            p{
                line-height: 32px;
            }
            .des-top{
                font-size: @FontSizeA2;
                line-height: 30px;
                .des-state{
                    margin-left: 20px;
                    display: inline-block;
                    color: @CooperateColorV1;
                    span{
                        padding: 5px;
                        background-color: rgba(228, 81, 81, 0.1);
                        border-radius: 5px;
                    }
                }
            }
            .des-bom{
                line-height: 32px;
                font-size: 13px;

            }

        }

    }
    .content-title{
        padding: 15px;
        border-bottom: 1px solid #e3e8ee;
        display: flex;
        justify-content:space-between;
        align-items:center;
        .state{
            display: flex;
            p{
                width: 130px;
                text-align: right;
            }
            p.green{
                color: green
            }
            p.gray{
                color: #666
            }
            p.red{
                color: red
            }
        }
    }
    .bottom-cen{
        border-bottom:1px solid #e3e8ee;
        padding: 10px;
        #brtmap{
            width: 100%;
            min-height: 600px;
            .normal{
                width: 2px;
                height: 2px;
                position: relative;
                .red-box{
                    width: 40px;
                    height: 40px;
                    background-image: url('../../../../public/images/redhang.png');
                    position: absolute;
                    transform: translate(-50%,-50%);
                }
                .img-box{
                    width: 40px;
                    height: 40px;
                    background-image: url('../../../../public/images/greenhand.png');
                    position: absolute;
                    transform: translate(-50%,-50%);
                }

                .normal-box{
                    position: absolute;
                    transform: translate(-50%,-96px);
                    width: 130px;
                    border-radius: 5px;
                    background-color: #01bf69;
                    color: #fff;
                    padding: 2px;
                    display: flex;
                    flex-direction:column;
                    p{
                        display: flex;
                        align-items: center;

                        width: 100%;
                        height: 22px;
                        padding: 0 5px;
                        span:first-child{
                            display: inline-block;
                            width: 13px;
                            height: 15px;
                             margin-right: 5px;
                              background-repeat: no-repeat
                        }
                        .person{
                            background-image: url('../../../../public/images/person.png');

                        }
                        .phone{
                             background-image: url('../../../../public/images/phone.png')
                        }
                        .address{
                            height: 17px !important;
                             background-image: url('../../../../public/images/address.png')
                        }
                    }
                    .down{
                        width:0;
                        height:0;
                        border-width:8px 8px 0;
                        border-style:solid;
                        border-color:#01bf69 transparent transparent;
                        position: absolute;
                        transform: translate(55px,66px)
                    }
                }
                .red-main{
                    background-color: #f03e00;
                    transform: translate(-50%,-120px);
                    .down{
                          border-color:#f03e00 transparent transparent;
                          transform: translate(55px,90px)
                    }
                    p.top{
                        border-bottom: solid #f78057 1px;
                        color: #ffff00;
                        text-indent: 5px;
                    }
                }
            }
        }

    }
    .ivu-notice-notice{
        background-color: #ffdcd0;
        border-left: solid 4px #f53100;
    }
</style>
